import * as React from 'react'
import cx from 'classnames'
import styles from './FilterControlsToggleButton.sass'
import { IconButton } from '../IconButton'
import Icon from '../Icon'
import UnreadBadge from '../UnreadBadge'

interface FilterControlsToggleButtonProps {
  active: boolean
  count: number
  onClick: () => void
}

/**
 * The FilterControlsToggleButton
 */
export default function FilterControlsToggleButton({
  active,
  count,
  onClick,
}: FilterControlsToggleButtonProps) {
  return (
    <div className={cx(styles.root, active && styles.active)}>
      <IconButton inheritColor onClick={onClick}>
        <Icon name="filter" />
      </IconButton>
      <div className={styles.badge}>
        {count > 0 && <UnreadBadge count={count} />}
      </div>
    </div>
  )
}
